module.exports = __webpack_public_path__ + "img/bg_aviodPhoney_02.ecac6194.jpg";